<template>
  <li class="tree-node">
    <div class="tree-node-label">
      <button
        v-if="hasChildren"
        type="button"
        class="tree-toggle-btn"
        @click="expanded = !expanded"
        :aria-label="expanded ? 'Recolher grupo' : 'Expandir grupo'"
      >
        <i :class="['fas', expanded ? 'fa-chevron-down' : 'fa-chevron-right']"></i>
      </button>
      <span v-else class="tree-toggle-placeholder"></span>
      <span :class="['badge mr-2', node.status ? 'badge-success' : 'badge-secondary']">
        {{ node.status ? 'Ativo' : 'Inativo' }}
      </span>
      <strong>{{ node.nome }}</strong>
      <span v-if="hasManuais" class="badge manual-count-badge ml-2" :title="`${manuaisDoNo.length} manual(is)`">
        {{ manuaisDoNo.length }} manual(is)
      </span>

      <div class="tree-node-actions">
        <button
          type="button"
          class="tree-action-btn"
          title="Adicionar subgrupo"
          @click="$emit('add-child', node)"
        >
          <i class="fas fa-plus"></i>
        </button>
        <button
          type="button"
          class="tree-action-btn"
          title="Editar grupo"
          @click="$emit('edit', node)"
        >
          <i class="fas fa-pen"></i>
        </button>
        <button
          type="button"
          class="tree-action-btn danger"
          title="Excluir grupo"
          @click="$emit('delete', node)"
        >
          <i class="fas fa-trash"></i>
        </button>
      </div>
    </div>

    <ul v-if="hasManuais && expanded" class="manual-list">
      <li v-for="manual in manuaisDoNo" :key="`manual-${manual.id}`" class="manual-item">
        <button type="button" class="manual-link" @click="openManual(manual.id)">
          <i class="fas fa-book mr-1"></i>
          {{ manual.titulo }}
        </button>
        <span :class="['badge ml-2', manual.status ? 'badge-success' : 'badge-secondary']">
          {{ manual.status ? 'Ativo' : 'Inativo' }}
        </span>
      </li>
    </ul>

    <ul v-if="hasChildren && expanded" class="tree-children">
      <manual-tree-node
          v-for="child in node.children"
          :key="child.id"
          :node="child"
          @add-child="$emit('add-child', $event)"
          @edit="$emit('edit', $event)"
          @delete="$emit('delete', $event)"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'ManualTreeNode',
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expanded: true,
    };
  },
  computed: {
    hasChildren() {
      return Array.isArray(this.node.children) && this.node.children.length > 0;
    },
    manuaisDoNo() {
      if (Array.isArray(this.node.manuais)) {
        return this.node.manuais;
      }

      if (Array.isArray(this.node.manuals)) {
        return this.node.manuals;
      }

      return [];
    },
    hasManuais() {
      return this.manuaisDoNo.length > 0;
    },
  },
  methods: {
    openManual(id) {
      if (!id) return;
      this.$router.push(`/manuais/view/${id}`);
    },
  },
};
</script>

<style scoped>
.tree-children {
  list-style: none;
  padding-left: 20px;
  margin: 0;
}

.tree-node {
  margin: 8px 0;
}

.tree-node-label {
  display: flex;
  align-items: center;
  min-height: 28px;
}

.tree-node-label strong {
  margin-right: auto;
}

.tree-toggle-btn {
  width: 22px;
  height: 22px;
  border: 0;
  border-radius: 4px;
  background: transparent;
  color: #6c757d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  cursor: pointer;
}

.tree-toggle-btn:hover {
  background: #f1f3f5;
  color: #495057;
}

.tree-toggle-placeholder {
  width: 22px;
  margin-right: 6px;
  display: inline-block;
}

.tree-node-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
}

.tree-action-btn {
  width: 24px;
  height: 24px;
  border: 1px solid #d9dde3;
  border-radius: 4px;
  background: #fff;
  color: #6c757d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.tree-action-btn:hover {
  background: #f8f9fa;
  color: #495057;
}

.tree-action-btn.danger:hover {
  color: #c92a2a;
  border-color: #f1aeb5;
  background: #fff5f5;
}

.manual-list {
  list-style: none;
  padding-left: 28px;
  margin: 6px 0 0 0;
}

.manual-item {
  display: flex;
  align-items: center;
  margin: 4px 0;
}

.manual-link {
  border: 0;
  background: transparent;
  color: #334155;
  padding: 0;
  text-align: left;
  cursor: pointer;
}

.manual-link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}

.manual-count-badge {
  background: #e6f4ea;
  color: #1e6a3a;
  border: 1px solid #b7e4c7;
  font-weight: 600;
}
</style>
